import { getBlocks } from '@/api/blocks';
import { BlocksState } from '@/types/block';
import { RootState } from '@/types/store';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

type BlocksGetter = GetterTree<BlocksState, RootState>;

const state: BlocksState = {
  data: [],
  current_page: 1,
  first_page_url: 'http://cms.test/api/blocks?page=1',
  from: 1,
  last_page: 1,
  last_page_url: null,
  next_page_url: null,
  path: 'http://cms.test/api/blocks',
  per_page: 50,
  prev_page_url: null,
  to: 50,
  total: 0,
};

const getters: BlocksGetter = {
  blocks: state => state.data,
  currentBlock: state => state.current_page,
};

const actions: ActionTree<BlocksState, RootState> = {
  async getBlocks({ commit }): Promise<void> {
    commit('setBlocks', await getBlocks());
  },
};

const mutations: MutationTree<BlocksState> = {
  setBlocks(state: BlocksState, blockData: BlocksState): void {
    Object.assign(state, blockData);
  },
};

const blocks: Module<BlocksState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};

export default blocks;
